import Model from './Model'
export default class InternalAquisition extends Model {

    resource()
    {
        return 'internal-aquisitions'
    }

    mediaEndpoint() {
        return `${this.endpoint()}/attachments`
    }

    get paymentTypes() {
        return [{
            value: 'cash',
            text: 'Cash'
        }, {
            value: 'card',
            text: 'Card'
        }, {
            value: 'wire',
            text: 'Transfer Bancar'
        }]
    }

    get types() {
        return [{
            value: 'Birotica',
            text: 'Birotica',
            hint: 'Consumabile birou'
        },{
            value: 'Consumabile hala',
            text: 'Consumabile hala',
            hint: 'Tot ce se consuma in hala (Spray, suruburi, solutii de curatare, etc)'
        },{
            value: 'Achizitii stoc intern',
            text: 'Achizitii stoc intern',
            hint: 'Bunuri de uz intern (hartie igienica, pahare plastic, bidoane apa, solutii de curatat)'
        },{
            value: 'Achizitii stoc intern parc auto si utilaje',
            text: 'Achizitii stoc intern parc auto si utilaje',
            hint: 'Piese de schimb, servicii de reparatii, constatari si reparatii.'
        },{
            value: 'Diverse ',
            text: 'Diverse ',
            hint: 'Achizitii care nu se incadreaza in celelalte categorii'
        }]
    }
}
